import { render, staticRenderFns } from "./LastNewsBlock.vue?vue&type=template&id=56488ce0&scoped=true"
import script from "./LastNewsBlock.vue?vue&type=script&lang=js"
export * from "./LastNewsBlock.vue?vue&type=script&lang=js"
import style0 from "./LastNewsBlock.vue?vue&type=style&index=0&id=56488ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56488ce0",
  null
  
)

export default component.exports